import { Grid, MenuItem, Select } from '@material-ui/core';
import { Button } from '@material-ui/core/';
import React from 'react';

import { DEAL_SSP_WITH_API_LIST, IDealTPAccount } from '~/src/dash/api/deals';
import { IStore } from '~/src/dash/reducers/store';
import { IReduxActionProps, ISessionStateProps, IUserStateProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { toTitleCase } from '~/src/dash/utils/text-tools';

interface IProps extends IReduxActionProps, ISessionStateProps, IUserStateProps {
  tpAccounts: IDealTPAccount[];
  addNewAccountHandler: (apiName: string) => void;
}

interface IState {
  selectedAPI: string;
}

export const DealTPAccountAdd = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
  },
  class extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = {
        selectedAPI: '',
      };
    }

    // Check which API types are missing from the given account list.
    getMissingAPINameInAccountList(accountList: IDealTPAccount[]): string[] {
      const missingAPINameList: string[] = [];
      // For each API search if it's already added in the accountList.
      for (const apiName of DEAL_SSP_WITH_API_LIST) {
        if (
          accountList.findIndex((v) => v.APIName.toLowerCase() === apiName.toLowerCase()) === -1
        ) {
          // The current apiName is not in the accountList. Add it in the missingAPINameList.
          missingAPINameList.push(apiName);
        }
      }
      return missingAPINameList;
    }

    // Handles change when user select an API in the 'Partner' dropdown.
    handleSelectAPINameChange(selectedAPI: string): void {
      this.setState({
        selectedAPI,
      });
    }

    // Handles when the user click the "Add" button next to "Add a new account".
    handleAddClick(): void {
      // Unselect the partner in the dropdown.
      this.setState({ selectedAPI: '' });
      // Call change handler on parent.
      this.props.addNewAccountHandler(this.state.selectedAPI);
    }

    render() {
      // Get variables from state/props.
      const { tpAccounts } = this.props;
      const { selectedAPI } = this.state;

      // Check which API types are missing in the account list and can be created.
      const apiNameMissingInList = this.getMissingAPINameInAccountList(tpAccounts);

      // If there is no API missing from the added account, there is no account to add.
      if (apiNameMissingInList.length === 0) {
        return (
          <div style={{ marginBottom: '15px' }}>
            <i>All available partners have been added 🙌</i>
          </div>
        );
      }

      // By default, if nothing is selected we select the first API partner in the dropdown.
      if (selectedAPI === '') {
        this.setState({ selectedAPI: apiNameMissingInList[0] });
      }

      // Some API provider are missing from the account list, show the user the option to add it/them.
      return (
        <Grid
          container
          direction={'row'}
          justify={'flex-start'}
          alignItems={'center'}
          spacing={2}
          style={{ marginBottom: '13px' }}
        >
          {/* Text*/}
          <Grid item>
            <p style={{ fontSize: '17px', marginRight: '8px' }}>Add a new account: </p>
          </Grid>

          {/* Dropdown*/}
          <Grid item xs={2}>
            <Select
              value={selectedAPI}
              onChange={(e) => this.handleSelectAPINameChange(e.target.value as string)}
              fullWidth={true}
            >
              {apiNameMissingInList.map((apiName: string) => (
                <MenuItem value={apiName}>
                  {toTitleCase(apiName === 'rhythmone' ? 'Nexxen CTRL' : apiName)}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          {/* Add button*/}
          <Grid item>
            <Button color={'primary'} onClick={() => this.handleAddClick()}>
              Add
            </Button>
          </Grid>
        </Grid>
      );
    }
  },
);
